import * as React from 'react';
import PropTypes from 'prop-types';

const ExpandButtonRightIcon = ({ color = 'rgb(133, 137, 145)' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18C10.3 18 10.5 17.9 10.7 17.7L15.7 12.7C16.1 12.3 16.1 11.7 15.7 11.3L10.7 6.3C10.3 5.9 9.7 5.9 9.3 6.3C8.9 6.7 8.9 7.3 9.3 7.7L13.6 12L9.3 16.3C8.9 16.7 8.9 17.3 9.3 17.7C9.5 17.9 9.7 18 10 18Z"
      fill={color}
    />
  </svg>
);
export default ExpandButtonRightIcon;

ExpandButtonRightIcon.propTypes = {
  color: PropTypes.string,
};
